import React, { Component } from "react";
import { bindActionCreators } from "redux";

import connect from "react-redux/es/connect/connect";
import { trimFormData } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";
import queryString from "query-string";
import ContentDetailsInstagramView from "./ContentDetailsInstagramView";
//
import { addInstagramPublished } from "../../../../store/InstagramManagement/InstagramManagementActions";
import {
  getCategoryList,
  getTagsList,
  getStatusList,
  addNewTag,
} from "../../../../store/master/masterActions";

class ContentDetailsInstagramContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      tags: [],
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleTagChange = this.handleTagChange.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleAddMultipleTagList = this.handleAddMultipleTagList.bind(this);
    this.handleRemoveTag = this.handleRemoveTag.bind(this);
    //
    this.handelUpdateIds = this.handelUpdateIds.bind(this);
    this.handleInitialTags = this.handleInitialTags.bind(this);
    //
    this.onClickAddTag = this.onClickAddTag.bind(this);
    this.onClickContentDetailsSubmit =
      this.onClickContentDetailsSubmit.bind(this);
  }

  componentDidUpdate() {}

  componentDidMount() {
    this.props.getCategoryList();
    this.props.getTagsList();
    this.props.getStatusList();
  }

  componentWillUnmount() {}

  //--------------------------field handlers
  handleInputChange = ({ target }) => {
    const field = target.name;
    // console.log(this.state.fields);
    this.setState({
      fields: { ...this.state.fields, [field]: target.value },
      errors: {},
    });
  };

  handleCategoryChange = (value) => {
    console.log(this.state.fields);
    this.setState({
      fields: { ...this.state.fields, category: value },
    });
  };

  handleTagChange = (value) => {
    // console.log(this.state.fields);

    // const tag = this.state.fields?.tag;
    // const tagArray = tag?.length > 0 ? [...tag, value] : [value];
    // this.setState({
    //   fields: { ...this.state.fields, tag: tagArray, newTag: value },
    // });

    //-------------------------------
    console.log(this.state.fields);

    const { fields } = this.state;

    // Check if a tag with the same label already exists
    const tagExists = fields.tag?.some((tag) => tag.label === value.label);

    if (tagExists) {
      console.log(`Tag with label '${value.label}' already exists.`);
      return;
    }

    // If tag doesn't exist, add it to the tag array in fields
    const newTagArray =
      fields.tag?.length > 0 ? [...fields.tag, value] : [value];

    this.setState({
      fields: {
        ...fields,
        tag: newTagArray,
        newTag: value,
      },
    });
    console.log("value", value);
  };

  handleStatusChange = (value) => {
    console.log(this.state.fields);
    this.setState({
      fields: { ...this.state.fields, status: value },
    });
  };

  //--------------------------Add Multi tags
  handleAddMultipleTagList = (val) => {
    // if (this.state.tags?.length > 0) {
    //   this.setState((prev) => ({
    //     ...prev,
    //     tags: [...prev.tags, { label: val.label }],
    //   }));
    // } else {
    //   this.setState(
    //     (prev) => ({ ...prev, tags: [{ label: val.label }] }),
    //     console.log(this.state)
    //   );
    // }

    const { tags } = this.state;

    // Check if a tag with the same label already exists
    const tagExists = tags.some((tag) => tag.label === val.label);

    if (tagExists) {
      console.log(`Tag with label '${val.label}' already exists.`);
      return; // Exit early if tag already exists
    }

    // If tag doesn't exist, add it to the state
    this.setState((prev) => ({
      tags: [...prev.tags, { label: val.label }],
    }));
  };

  //--------------------------Update newly added tags ids

  handelUpdateIds = (tagDropDownOptions, callback) => {
    const tag = this.state.fields?.tag;

    tagDropDownOptions?.forEach((dropdownItem) => {
      tag?.forEach((tagItem) => {
        if (tagItem.__isNew__ && tagItem.label === dropdownItem.label) {
          tagItem.value = dropdownItem.value;
          //  remove the __isNew__ property
          delete tagItem.__isNew__;
        }
      });
    });

    const updatedTags = tag?.length > 0 ? [...tag] : [tag];

    this.setState(
      (prevState) => ({
        fields: {
          ...prevState.fields,
          tag: [...updatedTags],
        },
      }),
      callback()
    );
  };

  //--------------------------Remove tag
  handleRemoveTag = (index) => {
    //---------------
    console.log("fields tag", this.state.fields.tag);
    console.log("UI tag", this.state.tags);

    const tagLabel = this.state.tags[index].label;

    this.setState(
      (prevState) => ({
        tags: prevState?.tags?.filter((_, i) => i !== index),
        fields: {
          ...prevState.fields,
          tag: prevState.fields?.tag?.filter((tag) => tag.label !== tagLabel),
        },
      }),
      console.log(this.state.tags)
    );
  };

  //--------------------------Add new tag
  onClickAddTag = () => {
    var fields = this.state.fields;
    const validatorFields = {
      required: ["tag"],
    };
    const { errors } = validator.validate(
      validatorFields,
      trimFormData(fields)
    );
    this.setState({ ...this.state, errors });
    console.log(errors);

    var fields = this.state.fields;
    if (!Object.keys(errors).length) {
      const data = {
        tag: fields.newTag?.value,
      };
      this.props.addNewTag(data);
    }
  };

  //--------------------------Update instagram video status/category/tag
  onClickContentDetailsSubmit = (id, isPublished, data, callback) => {
    var fields = this.state.fields;
    const existingData = data;
    // Extracting values from tag array
    const extractTagValues = (tags) => tags.map((tag) => tag.value);
    const validatorFields = isPublished
      ? { required: [] }
      : { required: ["category", "tag", "status"] };

    const { errors } = validator.validate(
      validatorFields,
      trimFormData(fields)
    );
    this.setState({ ...this.state, errors });
    console.log(errors);

    var fields = this.state.fields;
    if (!Object.keys(errors).length) {
      const data = {
        categoryId: fields?.category?.value || existingData?.category,
        tag: extractTagValues(fields?.tag) || existingData?.tag,
        status: fields?.status?.value || existingData?.status,
      };
      console.log("json data", data);
      this.props.addInstagramPublished(id, data);
      callback();
    }
  };

  //--------------------------Already existing Tags of Youtube video
  // handleInitialTags = (tagValue) => {
  //   const formattedTags = tagValue?.map((tag) => ({
  //     value: tag._id,
  //     label: tag.tag,
  //   }));

  //   this.setState((prev) => ({
  //     ...prev,
  //     fields: { tag: formattedTags.length > 0 && [...formattedTags] },
  //     tags: formattedTags.length > 0 && [...formattedTags],
  //   }));
  // };

  handleInitialTags = (tagValue) => {
    const formattedTags =
      tagValue?.map((tag) => ({
        value: tag._id,
        label: tag.tag,
      })) || [];

    this.setState((prev) => ({
      ...prev,
      fields: { tag: [...formattedTags] },
      tags: [...formattedTags],
    }));
  };

  render() {
    const parsed = queryString.parse(window.location.search);
    const dataId = parsed.id;
    // console.log("dataId", dataId);

    //--------------------------dropdown options
    const categoryDropDownOptions = this.props.categories?.map((item) => {
      return {
        label: item?.categoryName,
        value: item?._id,
      };
    });

    const statusDropDownOptions = this.props.status?.map((item) => {
      return {
        label: item?.status,
        value: item?._id,
      };
    });

    const tagDropDownOptions = this.props.tags?.map((item) => {
      return {
        label: item?.tag,
        value: item?._id,
      };
    });

    return (
      <ContentDetailsInstagramView
        //all the states
        fields={this.state?.fields}
        instagramList={this.props.instagramList?.filter(
          (item) => item._id === dataId
        )}
        tags={this.state.tags}
        errors={this.state.errors}
        //input handler
        handleInputChange={this.handleInputChange}
        handleCategoryChange={this.handleCategoryChange}
        handleTagChange={this.handleTagChange}
        handleStatusChange={this.handleStatusChange}
        handleAddMultipleTagList={this.handleAddMultipleTagList}
        handleRemoveTag={this.handleRemoveTag}
        //
        handelUpdateIds={this.handelUpdateIds}
        handleInitialTags={this.handleInitialTags}
        //APIs
        onClickAddTag={this.onClickAddTag}
        onClickContentDetailsSubmit={this.onClickContentDetailsSubmit}
        //dropdown Options
        categoryDropDownOptions={categoryDropDownOptions}
        statusDropDownOptions={statusDropDownOptions}
        tagDropDownOptions={tagDropDownOptions}
      />
    );
  }
}

ContentDetailsInstagramContainer.propTypes = {};

const mapStateToProps = (state) => ({
  instagramList: state.instagramManagement.instagramList,
  categories: state.master.categories,
  tags: state.master.tags,
  status: state.master.status,
});

export default connect(mapStateToProps, {
  getCategoryList,
  getTagsList,
  getStatusList,
  addNewTag,
  addInstagramPublished,
})(ContentDetailsInstagramContainer);
